import Vue from 'vue'

export const getFlagRealtimeValue = async (flagKey, waitUntilReady = true) => {
  const ldClient = await Vue.prototype.$launchDarkly.getClient(waitUntilReady)

  return ldClient.variation(flagKey, false)
}
